"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestLeaderboardProfileAllOfToJSON = exports.QuestLeaderboardProfileAllOfFromJSONTyped = exports.QuestLeaderboardProfileAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
function QuestLeaderboardProfileAllOfFromJSON(json) {
    return QuestLeaderboardProfileAllOfFromJSONTyped(json, false);
}
exports.QuestLeaderboardProfileAllOfFromJSON = QuestLeaderboardProfileAllOfFromJSON;
function QuestLeaderboardProfileAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nickname': !(0, runtime_1.exists)(json, 'nickname') ? undefined : json['nickname'],
        'gravatar': !(0, runtime_1.exists)(json, 'gravatar') ? undefined : json['gravatar'],
    };
}
exports.QuestLeaderboardProfileAllOfFromJSONTyped = QuestLeaderboardProfileAllOfFromJSONTyped;
function QuestLeaderboardProfileAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nickname': value.nickname,
        'gravatar': value.gravatar,
    };
}
exports.QuestLeaderboardProfileAllOfToJSON = QuestLeaderboardProfileAllOfToJSON;
